<template>
  <div class="number-range-wrap">
    <el-input-number
      v-model="state.rangeValue[0]"
      :max="state.rangeValue[1] ? state.rangeValue[1] : undefined"
      :min="minInitialValue !== null ? minInitialValue : undefined"
      :placeholder="placeholders[0]"
      @blur="inputNumberBlur(0, state.rangeValue[0])"
    />
    <span v-if="joinText" class="join-text">{{ joinText }}</span>
    <el-input-number
      v-model="state.rangeValue[1]"
      :min="state.rangeValue[0] ? state.rangeValue[0] : 0"
      @blur="inputNumberBlur(1, state.rangeValue[1])"
      :placeholder="placeholders[1]"
    />
    <span v-if="unitText" class="unit-text">{{ unitText }}</span>
  </div>
</template>

<script lang="ts">
import type { UnwrapNestedRefs } from "vue";
import isArray from "lodash-es/isArray";
import { ElInputNumber } from "element-plus";
import { defineComponent, onMounted, reactive, watch } from "vue";
import type { ComponentPublicInstance, ExtractPropTypes, PropType, SetupContext, StyleValue, VNode } from "vue";
import { buildProps } from "../../utils/props";

import { cloneDeep } from "lodash-es";
/*
  数字范围组件
*/

const NumberRangeProps = buildProps({
  modelValue: {
    type: Array as PropType<number[]>,
    default: () => [],
  },
  joinText: {
    type: String,
    default: "-",
  },
  unitText: {
    type: String,
    default: "",
  },
  placeholders: {
    type: Array,
    default: () => [],
  },
  minInitialValue: {
    type: [Number, null],
    default: null,
  },
});

type NumberRangePropsType = ExtractPropTypes<typeof NumberRangeProps>;
export default defineComponent({
  name: "NumberRange",
  components: {
    ElInputNumber,
  },

  props: NumberRangeProps,
  setup(props: NumberRangePropsType, ctx: SetupContext<any>) {
    const state: UnwrapNestedRefs<{ rangeValue: number[] }> = reactive({
      rangeValue:
        props.modelValue && isArray(props.modelValue)
          ? cloneDeep(props.modelValue)
          : [],
    });

    function inputNumberBlur(index: number, val: number): void {
      state.rangeValue[index] > Number(999999999)
        ? state.rangeValue.splice(index, 1, Number(999999999))
        : false;
      ctx.emit("update:modelValue", state.rangeValue);
    }
    watch(
      () => props.modelValue,
      (newVal) => {
        if (state.rangeValue != newVal) state.rangeValue = newVal;
      }
    );
    watch(
      () => state.rangeValue,
      (newVal) => {
        ctx.emit("update:modelValue", state.rangeValue);
      },
      {
        deep: true,
      }
    );
    return {
      state,
      inputNumberBlur,
    };
  },
});
</script>

<style lang="scss" scoped>
.number-range-wrap {
  display: flex;
  :deep( .el-el-input-number ) {
    flex: 1;
  }
  .join-text {
    padding: 0 5px;
  }
  .unit-text {
    padding: 0 5px;
  }
}
</style>
